import { Injectable } from '@angular/core';

import {HttpClient, HttpHeaders} from "@angular/common/http";
import {MyCONST} from "../../CONST/myConst";
import {map} from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})
export class FormulaireService {
  API_URL = MyCONST.API_PUBLIC
  token :any
  token_type: any

  my_inputs: any
  all_entries: any

  constructor(private http:HttpClient) {
    this.getToken()
    this.getEntriesType()
  }

  getToken(): any {
    const tok = localStorage.getItem('token');
    const type = localStorage.getItem('type');
    if (tok != null) {
      this.token = tok;
      this.token_type = type
    }
    return this.token;
  }

  getFormInputs(ref: any): any {
    //this.getToken();
    const headers = new HttpHeaders({
      'Authorization': this.token_type.replaceAll('"','')+' '+this.token.replaceAll('"','')
    });
    return this.http.get<any>(this.API_URL + '/management/formEntries/'+ref, { headers: headers })
      .pipe(
        map(rapports => {
          this.my_inputs = []
          this.my_inputs = rapports
          return rapports;
        })
      );
  }
  getFormInputsOther(ref: any): any {
    //this.getToken();
    const headers = new HttpHeaders({
      'Authorization': this.token_type.replaceAll('"','')+' '+this.token.replaceAll('"','')
    });
    return this.http.get<any>(this.API_URL + '/v0/formEntries/'+ref, { headers: headers })
      .pipe(
        map(rapports => {
          this.my_inputs = []
          this.my_inputs = rapports
          return rapports;
        })
      );
  }


  getEntriesType(): any {
    //this.getToken();
    const headers = new HttpHeaders({
      'Authorization': this.token_type.replaceAll('"','')+' '+this.token.replaceAll('"','')
    });
    return this.http.get<any>(this.API_URL + '/management/entriesTypes/', { headers: headers })
      .pipe(
        map(rapports => {
          this.all_entries = []
          this.all_entries = rapports
          return rapports;
        })
      );
  }

  createFormInput(form: any){
    const headers = new HttpHeaders({
      'Authorization': this.token_type.replaceAll('"','')+' '+this.token.replaceAll('"','')
    });

    return this.http.post(this.API_URL + '/management/formEntrie/',
      form,{ headers: headers }
    ).pipe(
      map((resultat: any) => {
        return resultat;
      }),
    );
  }

  createFormForComplement(form: any){
    const headers = new HttpHeaders({
      'Authorization': this.token_type.replaceAll('"','')+' '+this.token.replaceAll('"','')
    });

    return this.http.post(this.API_URL + '/operator/addcomplement/',
      form,{ headers: headers }
    ).pipe(
      map((resultat: any) => {
        return resultat;
      }),
    );
  }

  sendFormComplementData(form: any){
    const headers = new HttpHeaders({
      'Authorization': this.token_type.replaceAll('"','')+' '+this.token.replaceAll('"','')
    });

    return this.http.post(this.API_URL + '/v0/operations/complements/',
      form,{ headers: headers }
    ).pipe(
      map((resultat: any) => {
        return resultat;
      }),
    );
  }

  updateFormInput(form: any,id:any){
    const headers = new HttpHeaders({
      'Authorization': this.token_type.replaceAll('"','')+' '+this.token.replaceAll('"','')
    });

    return this.http.put(this.API_URL + '/management/formEntrie/'+id,
      form,{ headers: headers }
    ).pipe(
      map((resultat: any) => {
        return resultat;
      }),
    );
  }

  delateFormInput(id:any){
    const headers = new HttpHeaders({
      'Authorization': this.token_type.replaceAll('"','')+' '+this.token.replaceAll('"','')
    });

    return this.http.delete(this.API_URL + '/management/formEntrie/'+id,
      { headers: headers }
    ).pipe(
      map((resultat: any) => {
        return resultat;
      }),
    );
  }

}
